export const CREATE_COMMENT_BOX = "/wish/comments/createCommentBox";
export const ADD_COMMENT_PAGE = "/wish/comments/addCommentPage";
export const ADD_SINGLE_COMMENT = "/wish/comments/addSingleComment";
export const SET_COMMENT_TEXT = "/wish/comments/setCommentText";
export const REMOVE_COMMENT_BOX = "/wish/comments/removeCommentBox";
export const ADD_COMMENT_ATTACHMENTS = "/wish/comments/addCommentAttachments";
export const COMMENT_ADDED = "/wish/comments/commentAdded";
